import React from "react";

const NearBySvg = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M13.9273 23.2213L13.9268 23.2223C13.876 23.3416 13.7775 23.4332 13.6561 23.4751C13.5339 23.5172 13.3999 23.5056 13.2872 23.4433L13.2869 23.4432C13.1741 23.381 13.093 23.2741 13.0634 23.1491C13.0634 23.1489 13.0633 23.1486 13.0632 23.1484L10.9827 14.1141C10.9826 14.1137 10.9825 14.1132 10.9823 14.1128C10.9221 13.8462 10.7877 13.601 10.5932 13.4068C10.399 13.2123 10.1538 13.0779 9.88724 13.0177C9.88679 13.0176 9.88634 13.0175 9.88589 13.0174L0.851655 10.9368C0.851395 10.9367 0.851135 10.9367 0.850876 10.9366C0.725946 10.9071 0.619018 10.8259 0.55682 10.7131L0.556661 10.7128C0.49445 10.6002 0.482834 10.4661 0.52495 10.3439C0.566789 10.2225 0.65843 10.124 0.777649 10.0732L0.778688 10.0728L23.0447 0.52606C23.0448 0.525997 23.045 0.525934 23.0451 0.52587C23.1674 0.474018 23.3093 0.501583 23.4035 0.595824L23.4038 0.596142C23.4981 0.690378 23.5256 0.832484 23.4735 0.954908L23.3825 1.16863L13.9273 23.2213Z"
          fill="none"
          stroke="#118BF4"
        ></path>
      </svg>
    </>
  );
};

export default NearBySvg;
